import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';

import {UserUiPreference} from '../model/userUiPreference';
import {UserUiPreferenceUpdateDto} from '../model/userUiPreferenceUpdateDto';
import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';

@Injectable()
export class ConfiguratorUserUiPreferenceService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration
    ) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    public getCampaignListPreferenceUsingGET(
        xDataStoreID: string,
        X_PARTNER_ID?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<UserUiPreference>;
    public getCampaignListPreferenceUsingGET(
        xDataStoreID: string,
        X_PARTNER_ID?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<UserUiPreference>>;
    public getCampaignListPreferenceUsingGET(
        xDataStoreID: string,
        X_PARTNER_ID?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<UserUiPreference>>;
    public getCampaignListPreferenceUsingGET(
        xDataStoreID: string,
        X_PARTNER_ID?: string,
        observe: any = 'body',
        reportProgress = false
    ): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling getCampaignListPreferenceUsingGET.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        const httpHeaderAccepts: string[] = ['application/json'];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        return this.httpClient.get<UserUiPreference>(
            `${this.basePath}/api/user-ui-preferences/campaign-list`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    public saveCampaignListPreferenceUsingPUT(
        xDataStoreID: string,
        body: UserUiPreferenceUpdateDto,
        X_PARTNER_ID?: string,
        observe?: 'body',
        reportProgress?: boolean
    ): Observable<UserUiPreference>;
    public saveCampaignListPreferenceUsingPUT(
        xDataStoreID: string,
        body: UserUiPreferenceUpdateDto,
        X_PARTNER_ID?: string,
        observe?: 'response',
        reportProgress?: boolean
    ): Observable<HttpResponse<UserUiPreference>>;
    public saveCampaignListPreferenceUsingPUT(
        xDataStoreID: string,
        body: UserUiPreferenceUpdateDto,
        X_PARTNER_ID?: string,
        observe?: 'events',
        reportProgress?: boolean
    ): Observable<HttpEvent<UserUiPreference>>;
    public saveCampaignListPreferenceUsingPUT(
        xDataStoreID: string,
        body: UserUiPreferenceUpdateDto,
        X_PARTNER_ID?: string,
        observe: any = 'body',
        reportProgress = false
    ): Observable<any> {
        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling saveCampaignListPreferenceUsingPUT.');
        }
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling saveCampaignListPreferenceUsingPUT.');
        }

        let headers = this.defaultHeaders;
        headers = headers.set('X-DataStoreID', String(xDataStoreID));
        if (X_PARTNER_ID !== undefined && X_PARTNER_ID !== null) {
            headers = headers.set('X-PARTNER-ID', String(X_PARTNER_ID));
        }

        const httpHeaderAccepts: string[] = ['application/json'];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<UserUiPreference>(
            `${this.basePath}/api/user-ui-preferences/campaign-list`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }
}
